// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__I_GmD","movement":"skeleton_movement__aU349"};